import { TAG_STATUSES, PROCESSING_STATUSES } from '@/constants/moderation';

export const isTagConfirmed = (tag) => tag.status === TAG_STATUSES.CONFIRMED;

export const isTagRejected = (tag) => tag.status === TAG_STATUSES.REJECTED;

export const getVisibleTags = (content) => content.tags.filter((tag) => !isTagRejected(tag));

export const areAllTagsConfirmed = (tags) => tags.every(isTagConfirmed);

export const isContentEnabled = (content) => content.processing_status === PROCESSING_STATUSES.VISIBLE;

export const isContentDisabled = (content) => content.processing_status === PROCESSING_STATUSES.DISABLED || content.processing_status === PROCESSING_STATUSES.SPAM;

export const isContentReviewable = (content, visibleTags) => !content.have_tags_changed
    && ((visibleTags.length === 0 && isContentEnabled(content)) || (visibleTags.length > 0 && areAllTagsConfirmed(visibleTags) && isContentDisabled(content)));
